import React, {useState, useMemo, useContext} from 'react';
import styled from 'styled-components';

import theme, {bp, color} from 'settings/theme';

import {SearchContext} from 'services/searchService';


type Props = {
  title: string,
  paramType: SearchParamType,
  children: React.ReactNode
};


// Component
const Component: React.FC<Props> = (props) => {

  const search = useContext(SearchContext);

  const show = useMemo(() => {
    let facet = search.facets![props.paramType?.name]
    return facet && facet.options && facet.options.length > 0 ? true : false;
  }, [props.paramType, search.facets![props.paramType?.name]]);

  return (
    <>
      {show && 
        <StyledComponent className="searchFilter">

          <div className="searchFilter-titleLayout">
            <div className="searchFilter-titleLayout-left">
              <h4>{props.title}</h4>
            </div>
            <div className="searchFilter-titleLayout-right">
              {/* Clear button can go here */}
            </div>
          </div>

          {props.children}

        </StyledComponent>
      }
    </>
  );

}

export default Component;



// Styles
const StyledComponent = styled.div`

  display: block;
  padding: 24px 20px;
  font-size: 14px;
  border-bottom: solid 1px ${color.lines};

  
  .searchFilter-titleLayout{
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: -3px;
    margin-bottom: 18px;
  }

  .searchFilter-titleLayout-left{

    display: flex;
    align-items: center;

    h4{
      font-size: 18px;
      font-weight: bold;
    }

  }

  .searchFilter-titleLayout-right{
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }


`



